import React, { useState } from 'react';
import './Products.css';

const Products = () => {
  // Pricing data from SVG website
  const pricingData = {
    java: {
      ktk: {
        name: "KTK Origin JAVA Prices",
        counts: ["60/70", "70/80", "80/90", "90/100", "140/160"],
        prices: [1460, 1400, 1250, 1200, 1130]
      },
      aptn: {
        name: "AP/TN JAVA Prices", 
        counts: ["50/60", "60/70", "70/80", "80/90", "90/100", "140-160"],
        prices: [1540, 1450, 1385, 1240, 1190, 1115]
      },
      gujarat: {
        name: "GUJARAT JAVA Prices",
        counts: ["50/60", "60/70", "70/80", "80/90", "90/100", "140/160"],
        prices: [1540, 1470, 1390, 1210, 1180, 1090]
      }
    },
    tj: {
      gujarat: {
        name: "GUJARAT TJ Prices",
        counts: ["50/60", "60/70", "80/90"],
        prices: [1250, 1220, 1180]
      }
    },
    bold: {
      gujarat: {
        name: "GUJARAT BOLD Prices",
        counts: ["40/50", "50/60", "60/70", "70/80", "80/90"],
        prices: [1260, 1210, 1180, 1150, 1120]
      }
    },
    blanchedWhole: {
      gujarat: {
        name: "GUJARAT BLANCHED WHOLE Prices",
        counts: ["38/42", "40/50", "50/60"],
        prices: [1630, 1590, 1560]
      }
    },
    blanchedSplit: {
      gujarat: {
        name: "GUJARAT BLANCHED SPLIT Prices",
        counts: ["40/50", "50/60"],
        prices: [1400, 1365]
      }
    }
  };

  const products = [
    {
      id: 'peanut-java',
      name: 'Peanut - JAVA',
      description: 'JAVA (SPANISH)',
      image: '/assets/product/java.jpg',
      features: {
        countsPerOunce: '50/60, 60/70, 70/80, 80/90, 90/100, 140/160',
        moisture: '5% to 7%',
        admixture: '1% max',
        foreignMatter: '0.5% max',
        aflatoxin: '5 PPB [TLC method]',
        oilContent: '48 to 52%',
        availability: 'Whole year',
        packing: 'Jute Bag: 5kg, 10kg, 15kg, 25kg & 50kg\nPolypropylene Bag: 25kg, 50kg',
        loadability: 'Per 20 Feet: 20MTS'
      }
    },
    {
      id: 'peanut-tj',
      name: 'Peanut - TJ',
      description: 'TJ',
      image: '/assets/product/tj.jpg',
      features: {
        countsPerOunce: '50/60, 60/70, 70/80, 80/90',
        moisture: '5% to 7%',
        admixture: '1% max',
        foreignMatter: '0.5% max',
        aflatoxin: '5 PPB [TLC method]',
        oilContent: '48 to 52%',
        availability: 'Whole year',
        packing: 'Jute Bag: 5kg, 10kg, 15kg, 25kg & 50kg\nPolypropylene Bag: 25kg, 50kg',
        loadability: 'Per 20 Feet: 20MTS'
      }
    },
    {
      id: 'peanut-bold',
      name: 'Peanut - BOLD',
      description: 'BOLD (RUNNER)',
      image: '/assets/product/bold.jpg',
      features: {
        countsPerOunce: '40/50, 50/60, 60/70, 70/80, 80/90',
        moisture: '5% to 7%',
        admixture: '1% max',
        foreignMatter: '0.5% max',
        aflatoxin: '5 PPB [TLC method]',
        oilContent: '48 to 52%',
        availability: 'Whole year',
        packing: 'Jute Bag: 5kg, 10kg, 15kg, 25kg & 50kg\nPolypropylene Bag: 25kg, 50kg',
        loadability: 'Per 20 Feet: 19MTS (For Bold)'
      }
    },
    {
      id: 'peanut-blanched-whole',
      name: 'Peanut - BLANCHED (WHOLE)',
      description: 'BLANCHED WHOLE',
      image: '/assets/product/blanched-whole.png',
      features: {
        countsPerOunce: 'C38/42, 40/50, 50/60',
        moisture: '4% to 5%',
        admixture: 'N/A',
        foreignMatter: 'N/A',
        aflatoxin: 'Aflatoxin negative & < 5 PPB [TLC method]',
        oilContent: 'N/A',
        availability: 'Whole year',
        packing: 'Vacuum Bag: 5kg, 10kg, 15kg, 25kg & 50kg\nCarton Box: 5kg, 10kg, 15kg, 25kg & 50kg\nPolypropylene Bag: 25kg, 50kg',
        loadability: 'Per 20 Feet: 19MTS'
      }
    },
    {
      id: 'peanut-roasted-blanched-split',
      name: 'Peanut - ROASTED & BLANCHED (SPLIT)',
      description: 'ROASTED & BLANCHED SPLIT',
      image: '/assets/product/blanched-spli.jpg',
      features: {
        countsPerOunce: '100% Split',
        moisture: '4% to 5%',
        admixture: 'N/A',
        foreignMatter: 'N/A',
        aflatoxin: 'Aflatoxin negative & < 5 PPB [TLC method]',
        oilContent: 'N/A',
        availability: 'Whole year',
        packing: 'Vacuum Bag: 5kg, 10kg, 15kg, 25kg & 50kg\nCarton Box: 5kg, 10kg, 15kg, 25kg & 50kg\nPolypropylene Bag: 25kg, 50kg',
        loadability: 'Per 20 Feet: 19MTS'
      }
    },
    {
      id: 'peanut-in-shell',
      name: 'Peanut - IN SHELL',
      description: 'IN SHELL',
      image: '/assets/product/in-shell.jpg',
      features: {
        countsPerOunce: '190-215 peanuts / 200g',
        moisture: '6% to 8%',
        admixture: '1% max',
        foreignMatter: 'Soil: Max 2.5%\nRubbish and Yam: NIL',
        aflatoxin: '5 PPB [TLC method]',
        oilContent: 'N/A',
        availability: 'Whole year',
        packing: 'Jute Bags: 35kgs',
        loadability: 'Per 20 Feet: 19MTS',
        sortationGrading: 'One-seed: Max 5%\nTwo-seed: Min 90%\nThree-seed: Max 5%'
      }
    }
  ];

  return (
    <div className="products-page">
      {/* Hero Section */}
      <section className="products-hero">
        <div className="hero-background"></div>
        <div className="hero-gradient"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Our <span>Products</span></h1>
              <p className="lead">
                Premium quality peanut products with international standards, 
                processed and exported worldwide for over 26 years.
              </p>
            </div>
            <div className="hero-visual">
              <div className="product-badges">
                <div className="badge-item">
                  <i className="fa fa-star"></i>
                  <span>Premium Quality</span>
                </div>
                <div className="badge-item">
                  <i className="fa fa-globe"></i>
                  <span>Global Export</span>
                </div>
                <div className="badge-item">
                  <i className="fa fa-certificate"></i>
                  <span>ISO Certified</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Overview */}
      <section className="section products-overview">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-header text-center">
                <h2>Peanut Products</h2>
                <p className="lead">
                  We offer a wide range of premium quality peanut products that meet international standards
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="section products-grid">
        <div className="container">
          <div className="row">
            {products.map((product, index) => (
              <div key={product.id} id={product.id} className="col-md-6 col-lg-4 mb-4">
                <div className="product-card">
                  <div className="product-image">
                    <img 
                      src={product.image} 
                      alt={product.name} 
                      className="img-responsive"
                    />
                    <div className="product-badge">
                      <i className="fa fa-star"></i>
                      <span>Premium</span>
                    </div>
                  </div>
                  <div className="product-header">
                    <h3>{product.name}</h3>
                    <p className="product-description">{product.description}</p>
                  </div>
                  <div className="product-features">
                    <table className="table table-striped">
                      <tbody>
                        <tr>
                          <td><strong>Counts per Ounce:</strong></td>
                          <td className="feature-value">{product.features.countsPerOunce}</td>
                        </tr>
                        <tr>
                          <td><strong>Moisture:</strong></td>
                          <td className="feature-value">{product.features.moisture}</td>
                        </tr>
                        {product.features.admixture !== 'N/A' && (
                          <tr>
                            <td><strong>Admixture:</strong></td>
                            <td className="feature-value">{product.features.admixture}</td>
                          </tr>
                        )}
                        {product.features.foreignMatter !== 'N/A' && (
                          <tr>
                            <td><strong>Foreign Matter:</strong></td>
                            <td className="feature-value" style={{whiteSpace: 'pre-line'}}>{product.features.foreignMatter}</td>
                          </tr>
                        )}
                        <tr>
                          <td><strong>Aflatoxin:</strong></td>
                          <td className="feature-value">{product.features.aflatoxin}</td>
                        </tr>
                        {product.features.oilContent !== 'N/A' && (
                          <tr>
                            <td><strong>Oil Content:</strong></td>
                            <td className="feature-value">{product.features.oilContent}</td>
                          </tr>
                        )}
                        <tr>
                          <td><strong>Availability:</strong></td>
                          <td className="feature-value">{product.features.availability}</td>
                        </tr>
                        <tr>
                          <td><strong>Packing:</strong></td>
                          <td className="feature-value" style={{whiteSpace: 'pre-line'}}>{product.features.packing}</td>
                        </tr>
                        <tr>
                          <td><strong>Loadability:</strong></td>
                          <td className="feature-value">{product.features.loadability}</td>
                        </tr>
                        {product.features.sortationGrading && (
                          <tr>
                            <td><strong>Sortation Grading:</strong></td>
                            <td className="feature-value" style={{whiteSpace: 'pre-line'}}>{product.features.sortationGrading}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <a href="/contact-us" className="btn btn-primary">
                    <i className="fa fa-envelope"></i> Contact Us
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Us Section */}
      <section className="section contact-products">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="contact-content text-center">
                <h2>Interested in Our Products?</h2>
                <p className="lead">
                  Get in touch with us for detailed product information, pricing, and availability. 
                  Our team is ready to assist you with your requirements.
                </p>
                <div className="contact-actions">
                  <a href="/contact-us" className="btn btn-primary btn-lg">
                    <i className="fa fa-envelope"></i> Contact Us Now
                  </a>
                  <a href="mailto:svgadag_12@yahoo.com" className="btn btn-outline-primary btn-lg">
                    <i className="fa fa-envelope"></i> Email Us
                  </a>
                </div>
                <div className="contact-info">
                  <div className="contact-item whatsapp-contact">
                    <svg className="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                    </svg>
                    <a href="https://wa.me/919448165266?text=Hello! I'm interested in your peanut export services. Could you please provide more information?" target="_blank" rel="noopener noreferrer">+91 944 816 5266</a>
                  </div>
                  <div className="contact-item">
                    <i className="fa fa-phone"></i>
                    <a href="tel:+919448165266">+91 944 816 5266</a>
                  </div>
                  <div className="contact-item">
                    <i className="fa fa-envelope"></i>
                    <a href="mailto:svgadag_12@yahoo.com">svgadag_12@yahoo.com</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Peanuts Section */}
      <section className="section about-peanuts">
        <div className="container">
          {/* Main content - full width */}
          <div className="row">
            <div className="col-md-12">
              <div className="peanuts-info">
                <h2>About Peanuts / Groundnut Kernels</h2>
                <p>
                  Peanuts go by many other local names – <strong>Earthnuts, Ground Nuts, Goober Peas, Monkey Nuts</strong> et al. 
                  Despite the name, a peanut is not really a nut, but a legume. A widely used oil seed in India, 
                  making it the second-largest producer in the world. Peanuts are rich in proteins, bring in nutty flavor, 
                  and over and above a longer shelf life.
                </p>
                <p>
                  Peanuts are available in different varieties: <strong>Bold or Runner, Java or Spanish, and Red Natal</strong>. 
                  In India, they are mostly grown under rain-fed conditions. Under <strong>APEDA</strong>'s strict adherence 
                  to quality measures, our Indian groundnut sellers and processors are preparing and supplying edible peanuts 
                  conforming to the highest standards.
                </p>
                <p>
                  At SVG, our core expertise lies in peanut/groundnut seeds and its variants. Apart from raw edible peanuts, 
                  we also supply <strong>Processed Peanuts – Peanut Roasted & Blanched Whole-type and Peanut Roasted & Blanched Split</strong>.
                </p>
              </div>
            </div>
          </div>
          
          {/* Key Benefits and Image - side by side */}
          <div className="row">
            <div className="col-md-8">
              <div className="peanuts-benefits">
                <h3>Key Benefits:</h3>
                <ul>
                  <li>Rich in proteins and healthy fats</li>
                  <li>Nutty flavor and longer shelf life</li>
                  <li>Available in multiple varieties (Bold, Java, Red Natal)</li>
                  <li>Conforms to APEDA quality standards</li>
                  <li>Processed and raw variants available</li>
                  <li>Second-largest producer globally</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="peanuts-image">
                <img 
                  src="/assets/cashews-impo.jpg" 
                  alt="Peanuts" 
                  className="img-responsive"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="section pricing-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-header text-center">
                <h2>Current Market Prices</h2>
                <p className="lead">
                  Competitive pricing for premium quality peanut products. All prices are per MT (Metric Ton) in USD.
                </p>
              </div>
            </div>
          </div>

          {/* JAVA Prices */}
          <div className="row mb-5">
            <div className="col-md-12">
              <h3 className="product-category-title">Peanut JAVA Prices</h3>
              <div className="row">
                {Object.values(pricingData.java).map((region, index) => (
                  <div key={index} className="col-md-4 mb-4">
                    <div className="pricing-table">
                      <h4>{region.name}</h4>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Count</th>
                              <th>Rate per MT</th>
                            </tr>
                          </thead>
                          <tbody>
                            {region.counts.map((count, idx) => (
                              <tr key={idx}>
                                <td>{count}</td>
                                <td>${region.prices[idx]}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* TJ Prices */}
          <div className="row mb-5">
            <div className="col-md-12">
              <h3 className="product-category-title">Peanut TJ Prices</h3>
              <div className="row">
                <div className="col-md-4 mb-4">
                  <div className="pricing-table">
                    <h4>{pricingData.tj.gujarat.name}</h4>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Count</th>
                            <th>Rate per MT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pricingData.tj.gujarat.counts.map((count, idx) => (
                            <tr key={idx}>
                              <td>{count}</td>
                              <td>${pricingData.tj.gujarat.prices[idx]}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* BOLD Prices */}
          <div className="row mb-5">
            <div className="col-md-12">
              <h3 className="product-category-title">Peanut BOLD Prices</h3>
              <div className="row">
                <div className="col-md-4 mb-4">
                  <div className="pricing-table">
                    <h4>{pricingData.bold.gujarat.name}</h4>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Count</th>
                            <th>Rate per MT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pricingData.bold.gujarat.counts.map((count, idx) => (
                            <tr key={idx}>
                              <td>{count}</td>
                              <td>${pricingData.bold.gujarat.prices[idx]}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* BLANCHED Prices */}
          <div className="row mb-5">
            <div className="col-md-12">
              <h3 className="product-category-title">Blanched Peanut Prices</h3>
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="pricing-table">
                    <h4>{pricingData.blanchedWhole.gujarat.name}</h4>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Count</th>
                            <th>Rate per MT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pricingData.blanchedWhole.gujarat.counts.map((count, idx) => (
                            <tr key={idx}>
                              <td>{count}</td>
                              <td>${pricingData.blanchedWhole.gujarat.prices[idx]}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <div className="pricing-table">
                    <h4>{pricingData.blanchedSplit.gujarat.name}</h4>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Count</th>
                            <th>Rate per MT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pricingData.blanchedSplit.gujarat.counts.map((count, idx) => (
                            <tr key={idx}>
                              <td>{count}</td>
                              <td>${pricingData.blanchedSplit.gujarat.prices[idx]}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Pricing Note */}
          <div className="row">
            <div className="col-md-12">
              <div className="pricing-note">
                <div className="alert alert-info">
                  <h4><i className="fa fa-info-circle"></i> Pricing Information</h4>
                  <ul>
                    <li>All prices are per Metric Ton (MT) in USD</li>
                    <li>Prices are subject to market fluctuations</li>
                    <li>Minimum order quantity may apply</li>
                    <li>Contact us for bulk order discounts and current availability</li>
                    <li>Prices may vary based on packaging requirements and delivery terms</li>
                  </ul>
                  <div className="text-center mt-3">
                    <a href="/contact-us" className="btn btn-primary btn-lg">
                      <i className="fa fa-envelope"></i> Get Custom Quote
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Products;
